import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class FooterService {
    async updateFooter(footerData) {
        if (footerData === null || footerData === undefined) {
            return new Promise((resolve, reject) => {
                reject('Data is empty');
            });
        } else {
            return await axios.put(Config.apiBasePath + '/theme/footer', footerData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        ...authHeader() // Add your authentication headers here if needed
                    }
                });
        }
    }

    async getFooter() {
        return await axios.get(Config.apiBasePath + '/theme/footer',
            {
                headers: {
                    'Content-Type': 'application/json',
                    ...authHeader() // Add your authentication headers here if needed
                }
            });
    }
}

export default new FooterService();